import axios from 'axios'


axios.interceptors.request.use(function (config) {
  config.timeout = 1000 & 20
  if(config.url.indexOf("http")!=-1){
    config.url=config.url
  }else{
    config.url='/api/v1'+config.url
  }

  return config
}, function (err) {
});
axios.interceptors.response.use(function (response) {

  return Object.assign(response.data, {httpStatus: response.status})

}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/axios.js